import apiV2 from "../../service/api/ApiV2";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {Equipment} from "../../interfaces/Equipment";

type EquipmentState = {
  data: Equipment[];
  loading: boolean;
  error: string | null;
};

const initialState: EquipmentState = {
  data: [],
  loading: false,
  error: null,
};

export const getEquipments = createAsyncThunk("equipments/getEquipments", async () => {
  return await apiV2.equipments();
});

const EquipmentSlice = createSlice({
  name: "equipments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEquipments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getEquipments.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getEquipments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "An error occurred while retrieving equipements";
        state.data = [];
      });
  },
});

export default EquipmentSlice.reducer;
